/** @jsxImportSource @emotion/react */

import assert from "assert";
import { WorkflowDiagramReactFlow } from "components/WorkflowEditor/WorkflowDiagram/WorkflowDiagramReactFlow";
import { useWorkflowEditorContext } from "components/WorkflowEditor/WorkflowEditorProvider/WorkflowEditorProvider";

export const WorkflowEditorPageGraph = () => {
  const { graphResults, graphSteps, graphEdges, graphInputs } =
    useWorkflowEditorContext((s) => {
      const resultOverrides = s.resultOverrides;
      const tableInfoOverrides = s.tableInfoOverrides;
      const graphData = s.workflowGraph;
      assert(graphData !== undefined, "Missing workflow graph");

      const graphSteps = graphData.steps.map((step) => {
        return {
          ...step,
          data: {
            label: tableInfoOverrides[step.table_id].name,
            subLabel: `(${step.tool_name} ${step.version.version})`,
          },
        };
      });

      const graphEdges = graphData.edges.map((e) => ({
        id: `${e.source}-${e.target}`,
        ...e,
      }));

      const graphInputs = graphData.inputs.map((i) => ({
        ...i,
        data: { label: i.name },
      }));

      const graphResults = graphData.results.map((r) => {
        const outputPolicy = resultOverrides[r.id].outputPolicy;
        return { ...r, data: { label: r.name, outputPolicy } };
      });

      return { graphResults, graphSteps, graphEdges, graphInputs };
    });

  return (
    <div style={{ height: "100%", width: "100%", minHeight: 300 }}>
      <WorkflowDiagramReactFlow
        graphNodes={graphSteps}
        graphEdges={graphEdges}
        graphInputs={graphInputs}
        graphResults={graphResults}
      />
    </div>
  );
};
